import { ChangeEventHandler } from 'react'
import { ICustomIconFile } from 'src/types'

type SetImage = (data: ICustomIconFile) => void

export const imageChangeHandler =
  (setImage: SetImage): ChangeEventHandler<HTMLInputElement> =>
  (e) => {
    const fileReader = new FileReader()
    fileReader.onload = () => {
      if (fileReader.readyState === 2) {
        e.target.files?.[0] &&
          setImage({
            file: e.target.files[0],
            icon: fileReader.result as string,
          })
        if (e.target) {
          e.target.value = ''
        }
      }
    }
    e.target.files?.length && fileReader.readAsDataURL(e.target.files[0])
  }
